<div>
    <div class="table-responsive pt-4">
        <table class="table table-hover mb-0">
            <thead>
            <tr>
                <th>
                    Select
                </th>
                <th>Zone</th>
                <th>Price</th>
                
            </tr>
            </thead>
            <tbody>
                <tr v-for="zonePricing in zonesPricing" v-if="zonesPricing.length > 0">
                    <td>
                        <input type="checkbox" v-model="zonePricing.selected" @change="onZoneSelect">
                    </td>
                    <td>{{zonePricing.description}}</td>
                    <td>
                        <currency-input class="form-control" v-model="zonePricing.price" 
                                        :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false, precision: precision }"
                                        :disabled="!zonePricing.selected" @blur="onZoneSelect"></currency-input>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</div>